import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PreNotaListComponent } from './pre-nota-list/pre-nota-list.component';
import { PreNotaEditComponent } from './pre-nota-edit/pre-nota-edit/pre-nota-edit.component';
import { EspecieResolve } from './pre-nota-edit/pre-nota-edit/especie.resolver';

const routes: Routes = [
    { path: '', component: PreNotaListComponent },
    // { path: 'stepper', component: PreNotaStepperComponent },
    {
        path: 'add', component: PreNotaEditComponent, resolve: {
            especie: EspecieResolve
        }
    },
    {
        path: 'edit/:idPreNota', component: PreNotaEditComponent, resolve: {
            especie: EspecieResolve
        }
    },
    {
        path: 'view/:idPreNota', component: PreNotaEditComponent, resolve: {
            especie: EspecieResolve
        }
    },
    {
        path: 'delete/:idPreNota', component: PreNotaEditComponent, resolve: {
            especie: EspecieResolve
        }
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class PreNotaRoutingModule { }
